import { Point } from '@ml/shared/types/point';
import { LocationPin } from '@ml/locations/types/location-pin.class';
import { TaskLocationStatus } from '@ml/tasks/types/enums/task-location-status.enum';

export class Location {
  id: number;
  name: string;
  startPoint: Point;
  points: Point[];
  customer?: number;
  status?: TaskLocationStatus;

  pins: LocationPin[];
}
